import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const BreakdownByIssuer = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${arg.argumentText}</div>
          <div>${arg.valueText} €</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Top 5 Breakdown by Issuer"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="issuersChart"
          ref={chartRef}
          palette={palette}
        >
          <Series valueField="value" argumentField="name" type="bar" />
          <ArgumentAxis
            label={{
              displayMode: "rotate",
              rotationAngle: 45,
            }}
          />
          <ValueAxis />
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default BreakdownByIssuer;
